import { authHttp } from '../http'
import * as routes from '../../routes/mdfe.routes'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function getMdfesByTp(tp_id = null, pInicial, pFinal) {
  try {
    if (!pInicial || !pFinal) {
      throw new Error('Período inicial e final são obrigatórios')
    }

    const dataInicial = parseToMysqlFormat(pInicial)
    const dataFinal = parseToMysqlFormat(pFinal)

    const response = await authHttp().get(routes.urlGetMdfeTpId(tp_id, dataInicial, dataFinal))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmitMdfe(content) {
  try {
    const response = await authHttp().post(routes.urlBaseMdfe, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteCancelMdfe(content) {
  try {
    const response = await authHttp().delete(routes.urlDeleteCancelMdfe, { data: content })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEncerrarMdfe(content) {
  try {
    const response = await authHttp().post(routes.urlEncerrarMdfe, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postSyncMdfe(content) {
  try {
    const response = await authHttp().post(routes.urlSyncMdfe, content)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getRotaParaMdfe(fleetId) {
  try {
    const response = await authHttp().get(routes.urlRotaParaMdfe(fleetId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVeiculoSugeridoMdfe(ctesIds) {
  try {
    const response = await authHttp().get(routes.urlVeiculoSugeridoMdfe(ctesIds))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
